<template>
  <ResponsiveLayout>
    <template #header_end><HeaderHelp /></template>
    <Spinner />
    <template #footer><FooterLinks v-if="!isFromApp()" /></template>
  </ResponsiveLayout>
</template>

<script setup>
import Spinner from '@shared/components/Spinner.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import FooterLinks from '@us/app/components/FooterLinks.vue'
import { isFromApp } from '@shared/helpers/isFromApp.js'
import HeaderHelp from '@us/app/components/HeaderHelp.vue'
</script>

<style lang="scss"></style>
